import { MotionValue } from 'framer-motion'
import React, { FC } from 'react'
import { HowItWorksSingleton } from '__generated__/sanity'
import { SectionBottomLine } from '../bottom-line'
import { SectionHeading } from '../section-heading'
import { Sections } from './Sections'

type EnhancingProps = HowItWorksSingleton['fields']['enhancing'] & {
  scrollY: MotionValue<number>
}

export const Enhancing: FC<EnhancingProps> = ({
  enhancingBottomDescription,
  enhancingTitle,
  enhancingBottomTitle,
  enhancingDescription,
  images,
  scrollY,
}) => {
  return (
    <>
      <SectionHeading title={enhancingTitle} description={enhancingDescription} />
      <Sections sections={images} scrollY={scrollY} />
      <SectionHeading title={enhancingBottomTitle} description={enhancingBottomDescription} />
      <SectionBottomLine />
    </>
  )
}
